module.exports = __webpack_public_path__ + "static/media/curlegance-4.c3221e61.jpg";